module.exports = __webpack_public_path__ + "img/seen-count-icon.daac5fbc.svg";